<app-modal-header title="Unwrap object" (onClose)="dialogRef.close()"></app-modal-header>

<mat-dialog-content>
  <div class="text-gray-400 text-sm">
    Unwrapping removes the top-level container and gives you direct access to the data inside. The data itself stays the same, only the outer wrapper is removed. Here's an example:
    <div class="my-2">
      <app-json-visualizer [data]="objectBefore" label="Data BEFORE unwrapping"></app-json-visualizer>
    </div>
    <div class="text-center">
      <i class="fas fa-arrow-down"></i>
    </div>
    <div class="my-2">
      <app-json-visualizer [data]="objectAfter" label="Data AFTER unwrapping"></app-json-visualizer>
    </div>
  </div>


</mat-dialog-content>
